export enum VitalSignTypes {
  BLOODPRESSURE = 'BLOODPRESSURE',
  BLOODPRESSURE_AND_PULSE = 'BLOODPRESSURE_AND_PULSE',
  BLOODSUGAR = 'BLOODSUGAR',
  BODYTEMPERATURE = 'BODYTEMPERATURE',
  O2SATURATION = 'O2SATURATION',
  O2GIVEN = 'O2GIVEN',
  OTHERVITALSIGNS = 'OTHERVITALSIGNS',
  PULSE = 'PULSE',
  QUICKVALUE = 'QUICKVALUE',
  WEIGHT = 'WEIGHT',
  BMI = 'BMI',
}
